var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('OrderStep',{attrs:{"step":4}}),_c('div',{staticClass:"container"},[_c('Confirmation',{attrs:{"mainText":_vm.confirmationMainText,"subText":_vm.confirmationSubText}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }